import Service from "../Service";

const resource = "orderpurchase/";

export default {
  updateObservation(ord, requestID) {
    return Service.post(resource + "updateobservation", ord, {
      params: { requestID: requestID },
    });
  },
  setStatus(ord, requestID) {
    return Service.post(resource + "setStatus", ord, {
      params: { requestID: requestID },
    });
  },
  closeOrder(ord, requestID) {
    return Service.post(resource + "closeOrder", ord, {
      params: { requestID: requestID },
    });
  },
  setStatusAfterDispatch(ord, requestID) {
    return Service.post(resource + "setStatusAfterDispatch", ord, {
      params: { requestID: requestID },
    });
  },
  save(ord, requestID, AccID) {
    return Service.post(resource + "save", ord, {
      params: { requestID: requestID, AccID: AccID },
    });
  },
  excel(dtr, requestID) {
    return Service.post(resource + "excel", dtr, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      params: { requestID: requestID },
    });
  },
  PDF(dtr, requestID) {
    return Service.post(resource + "pdf", dtr, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  byID(parameters, requestID) {
    return Service.post(resource + "byid", parameters, {
      params: { requestID: requestID },
    });
  },
  slopes(parameters, requestID) {
    return Service.post(resource + "slopes", parameters, {
      params: { requestID: requestID },
    });
  },
  loadExternal(parameters, UssUserID, requestID) {
    return Service.post(resource + "loadsapoutbound", parameters, {
      params: { UssUserID: UssUserID, requestID: requestID },
    });
  },
  loadExternalDemo(parameters, UsrID, requestID) {
    return Service.post(resource + "loadsapoutboundDemo", parameters, {
      params: { UssUserID: UsrID, requestID: requestID },
    });
  },
  loadPurchaseDeliveryNoteSapDemo(parameters, UssUserID, requestID) {
    return Service.post(resource + "loadPurchaseDeliveryNoteSapDemo", parameters, {
      params: { UssUserID, requestID },
    });
  },
  loadPurchaseInvoiceSapDemo(parameters, UssUserID, requestID) {
    return Service.post(resource + "loadPurchaseInvoiceSapDemo", parameters, {
      params: { UssUserID, requestID },
    });
  },
  getSupplierSearch() {
    return Vue.prototype.$http.defaults.baseURL + "/orderpurchase/ordersearch";
  },

    updateAccountDetail(detail, requestID) {
        return Service.post(resource + "updateAccountDetail", detail, {
            params: { requestID: requestID },
        });
    },
    getCategory() {
        return Service.get(resource + "category");
    },
    getShopper() {
        return Service.get(resource + "shopper");
    }
};
